class InfinitePageLoader extends HTMLElement {
  constructor() {
    super();

    this.sectionID = this.dataset.section || document.querySelector('infinite-page-loader')?.dataset.section || ''
    this.collectionInnerElement = document.querySelector('.collection_product_wrapper')
    this.saveScrollPoint();
    this.restoreScrollPoint();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.addObserver();
  }

  addObserver() {
    const observer = new window.IntersectionObserver(([entry]) => {
      // console.log('IntersectionObserverEntry:', entry); 
      if (entry.isIntersecting) {
        if (entry.target == this.loadActivatorElem)
          observer.disconnect();

        var nextPageUrl = this.getNextPageUrl()

        if (nextPageUrl)
          this.loadProducts(nextPageUrl)
      }

    }, {
      root: null,
      threshold: 0.005
    })

    observer.observe(this)
  }

  getNextPageUrl() {
    var nextPage = parseInt(this.dataset.currentpage) + 1;

    if (nextPage > this.dataset.totalpages) {
      return false
    }

    return this.constructURLWithSearchParams(nextPage)
  }

  constructURLWithSearchParams(page) {
    var params = new URLSearchParams(document.location.search)
    var nextPage = parseInt(page) || parseInt(this.dataset.currentpage) + 1;
    var pageParam = this.dataset.pageParam || 'page'

    params.set(pageParam, nextPage)
    // params.set('filter.v.availability', 1) // To set the available products by default

    var searchParamsAsString = params.toString()

    return "".concat(window.location.pathname, "?").concat(searchParamsAsString)
  }

  updateCurrentURL(url) {
    if (history.replaceState) {
      window.history.pushState({
        path: url
      }, '', url);
    }
  }

  loadProducts(url) {
    if (this.classList.contains('infinite-load')) return;

    this.classList.add('infinite-load')
    this.querySelector('div').classList.remove('hidden')

    this.getAndInsertHtml(url, 'append')
  }

  getAndInsertHtml(url, insertPosition) {
    var _this4 = this;

    if (this.abortController) {
      this.abortController.abort();
    }
    var currentUrl = new URL(url, window.location.href);
    currentUrl.searchParams.set('section_id', this.sectionID);

    try {
      this.abortController = new AbortController();

      fetch(currentUrl.toString(), {
        signal: this.abortController.signal
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = new DOMParser().parseFromString(content, "text/html");

          console.log("insertPosition", insertPosition)

          if (insertPosition == 'append') {
            //Appending new sets of product cards
            _this4.collectionInnerElement.insertAdjacentHTML('beforeend', tempElement.querySelector('.product_item').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('infinite-page-loader').dataset.currentpage
            _this4.dataset.totalpages = tempElement.querySelector('infinite-page-loader').dataset.totalpages
            console.log("collectionInnerElement", _this4.collectionInnerElement)
          }
          else if (insertPosition == 'prepend') {
            _this4.collectionInnerElement.insertAdjacentHTML('afterbegin', tempElement.querySelector('.product_item').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('load-previous-page').dataset.currentpage
          }

          _this4.init();
          _this4.saveScrollPoint();

          _this4.classList.remove('infinite-load')
          _this4.querySelector('div').classList.add('hidden')
        });
      });
    } catch (exception) { }
  }

  saveScrollPoint() {
    let productCards = document.querySelectorAll(".product_item");

    productCards.forEach((productCard) => {
      const observer = new IntersectionObserver((entries) => {
        observerCallback(entries, observer, productCard)
      },
        { threshold: 0.01 });
      observer.observe(productCard); // Observing each product card that is visible

      productCard.addEventListener('click', () => {
        sessionStorage.setItem("lastElementId", productCard.id);
      });
    })

    const observerCallback = (entries, observer, header) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting && entry.target.dataset.page) {
          this.updateCurrentURL(this.constructURLWithSearchParams(entry.target.dataset.page)) //updating the url depending on the product viewed
        }
      });
    };
  }

  restoreScrollPoint() {
    // Returning if browser is safari as it gets scrolled to top after scrollIntoView method is used.
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) return;

    history.scrollRestoration = "manual";
    // Reverting back to the previous element that was being viewed. 
    window.onload = function () {
      var lastElementId = sessionStorage.getItem("lastElementId");
      var lastElement = document.getElementById(lastElementId);

      if (lastElement)
        lastElement.scrollIntoView();

      sessionStorage.removeItem('lastElementId');
    };
  }


}

customElements.define('infinite-page-loader', InfinitePageLoader);